export default __webpack_public_path__ + "static/media/mainTitleMobile@3x.d3671bd0.png";